"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_TYPES = void 0;
exports.ERROR_TYPES = Object.freeze({
    NumberOfTagChildrenCannotBeAlteredError: 'NumberOfTagChildrenCannotBeAlteredError',
    TagExistsError: 'TagExistsError',
    TagHasChildrenError: 'TagHasChildrenError',
    TagParentDoesNotExistError: 'TagParentDoesNotExistError',
    ParentIdIsRequiredError: 'ParentIdIsRequiredError',
    CategorySubjectGroupNotAllowedError: 'CategorySubjectGroupNotAllowedError',
    TagSubjectGroupNotAllowedError: 'TagSubjectGroupNotAllowedError'
});
//# sourceMappingURL=errorTypes.js.map